import React, { useEffect } from "react";
import { Phone, MessageCircle, ChevronDown, Star } from "lucide-react";
import _MG_0072 from "../assets/all-images/carwash/_MG_0072.jpg";
import Exterior from "../assets/all-images/carwash/Exterior.jpg";
import _MG_0073 from "../assets/all-images/carwash/_MG_0073.jpg";
import _MG_0061 from "../assets/all-images/carwash/_MG_0061.jpg";





const SERVICES = [
  {
    id: 1,
    title: "Express Wash",
    price: "Contact Us",
    features: [
      "Exterior high-pressure rinse",
      "Soap foam application",
      "Tire & rim cleaning",
      "Microfiber hand dry",
      "Window wipe-down (exterior)"
    ],
    img: _MG_0072,
  },
  {
    id: 2,
    title: "Standard Interior",
    price: "Contact Us",
    features: [
      "Express Wash included",
      "Interior vacuuming (seats & mats)",
      "Dashboard dust & wipe",
      "Door jambs cleaning",
      "Air freshener application"
    ],
    img: Exterior,
  },
  {
    id: 3,
    title: "Full Service",
    price: "Contact Us",
    features: [
      "Complete exterior wash",
      "Deep interior vacuum",
      "Upholstery spot cleaning",
      "Trunk cleaning",
      "Tire shine application"
    ],
    img: _MG_0073,
  },
  {
    id: 4,
    title: "Engine Wash",
    price: "Contact Us",
    features: [
      "Degreaser application",
      "Low-pressure steam rinse",
      "Plastic dressing protection",
      "Leaf & debris removal",
      "Battery terminal check"
    ],
    img:_MG_0061,
  },
  {
    id: 5,
    title: "Premium Detailing",
    price: "Contact Us",
    features: [
      "Clay bar treatment",
      "Machine wax & polish",
      "Leather conditioning",
      "Headlight restoration",
      "Engine bay detail"
    ],
    img: _MG_0061,
  },
  {
    id: 6,
    title: "Ceramic Coating",
    price: "Contact Us",
    features: [
      "Paint correction (scratch removal)",
      "9H Ceramic layer application",
      "Hydrophobic protection",
      "UV damage shield",
      "1-year warranty shine"
    ],
    img: _MG_0061,
  },
];

const FAQS = [
  { q: "Do you come to my location?", a: "Yes! We have mobile units that can service your vehicle at your home or office." },
  { q: "How long does a full wash take?", a: "Typically 45-60 minutes depending on the condition of the vehicle." },
  { q: "What products do you use?", a: "We use premium, eco-friendly biodegradable soaps and waxes that are safe for your paint." },
];

export default function App() {
  useEffect(() => {
    document.title = "Car Wash Services";
  }, []);

  const handleCall = () => {
    window.location.href = "tel:+254720333127";
  };

  const handleWhatsApp = () => {
    window.open("https://wa.me/+254795906060", "_blank");
  };

  return (
    <div className="cw-root">
      <style>{`
        :root {
          --primary: #000D6B;
          --secondary: #ffffff;
          --accent: #FA8128;
          --accent-dark: #F28500;
          --btn-call: #000D6B;
          --btn-wa: #F9A826;
          --bg: #f8fafc;
          --text: #1e293b;
          --text-light: #64748b;
          --max-w: 1200px;
        }

        * { box-sizing: border-box; }
        body { margin: 0; padding: 0; }

        .cw-root {
          font-family: 'Inter', system-ui, -apple-system, sans-serif;
          background: var(--bg);
          color: var(--text);
          min-height: 100vh;
          display: flex;
          flex-direction: column;
        }

        .container { max-width: var(--max-w); margin: 0 auto; padding: 0 24px; }
        .text-center { text-align: center; }

        .section-header {
          text-align: center;
          margin-bottom: 48px;
        }

        .section-title {
          font-size: 32px;
          font-weight: 800;
          margin: 0 0 16px 0;
          color: var(--primary);
        }

        .section-desc {
          font-size: 18px;
          color: var(--text-light);
          max-width: 700px;
          margin: 0 auto;
          line-height: 1.6;
        }

        .hero {
          background: linear-gradient(rgba(0, 13, 107, 0.85), rgba(0, 13, 107, 0.7)),
            url('https://images.unsplash.com/photo-1601362840469-51e4d8d58785?auto=format&fit=crop&q=80&w=1600');
          background-size: cover;
          background-position: center;
          color: var(--secondary);
          padding: 120px 0;
          text-align: center;
          position: relative;
        }

        .hero h1 {
          font-size: 56px;
          font-weight: 900;
          margin: 0 0 24px 0;
          letter-spacing: -1px;
          text-shadow: 0 2px 10px rgba(0,0,0,0.3);
        }

        .hero p {
          font-size: 22px;
          opacity: 0.95;
          max-width: 700px;
          margin: 0 auto 32px auto;
          font-weight: 300;
        }

        .hero-btn {
          background: var(--accent);
          color: white;
          padding: 16px 32px;
          border-radius: 50px;
          text-decoration: none;
          font-weight: 700;
          font-size: 18px;
          display: inline-block;
          box-shadow: 0 4px 15px rgba(250, 129, 40, 0.4);
          transition: transform 0.2s, background 0.2s;
        }

        .hero-btn:hover {
          transform: translateY(-2px);
          background: var(--accent-dark);
        }

        .services-section { padding: 80px 0; }

        .grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 32px;
          align-items: stretch;
        }

        .card {
          background: var(--secondary);
          border-radius: 16px;
          overflow: hidden;
          box-shadow: 0 4px 20px rgba(0,0,0,0.06);
          transition: transform 0.3s ease, box-shadow 0.3s ease;
          display: flex;
          flex-direction: column;
          border: 1px solid #e2e8f0;
        }

        .card:hover {
          transform: translateY(-8px);
          box-shadow: 0 20px 40px rgba(0, 13, 107, 0.15);
        }

        .card-img { height: 220px; width: 100%; object-fit: cover; }
        .card-body { padding: 24px; display: flex; flex-direction: column; flex: 1; }
        .card-title { margin: 0; font-size: 24px; font-weight: 700; color: var(--primary); }
        .card-price { color: var(--accent); font-weight: 800; font-size: 20px; margin-top: 8px; margin-bottom: 20px; }

        .service-list {
          margin: 0;
          padding-left: 20px;
          color: var(--text-light);
          font-size: 15px;
          line-height: 1.8;
          flex: 1;
        }

        .service-list li { margin-bottom: 6px; }

        .card-actions {
          margin-top: 24px;
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 12px;
        }

        .btn {
          border: none;
          padding: 14px;
          border-radius: 8px;
          font-weight: 700;
          font-size: 14px;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          transition: filter 0.2s;
          color: white;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .btn:hover { filter: brightness(110%); }
        .btn-call { background-color: var(--btn-call); }
        .btn-wa { background-color: var(--btn-wa); }

        .info-section { background: white; padding: 80px 0; border-top: 1px solid #e2e8f0; }
        .split-layout { display: grid; grid-template-columns: 1fr 1fr; gap: 64px; }

        .faq-item { margin-bottom: 24px; border-bottom: 1px solid #f1f5f9; padding-bottom: 24px; }
        .faq-q { font-weight: 700; color: var(--primary); display: flex; align-items: center; justify-content: space-between; margin-bottom: 12px; font-size: 16px; }
        .faq-a { color: var(--text-light); line-height: 1.6; font-size: 15px; }

        .testimonial {
          background: #f8fafc;
          padding: 32px;
          border-radius: 16px;
          margin-bottom: 24px;
          border: 1px solid #eef2f6;
          position: relative;
        }

        .testimonial p { font-style: italic; color: #475569; margin: 0 0 16px 0; line-height: 1.6; font-size: 16px; }
        .testimonial-author { font-weight: 700; font-size: 15px; color: var(--primary); display: flex; align-items: center; gap: 8px; }
        .stars { display: flex; gap: 4px; }

        .footer-mini { background: var(--primary); color: rgba(255,255,255,0.7); padding: 32px 0; font-size: 14px; text-align: center; }

        @media (max-width: 960px) {
          .grid { grid-template-columns: repeat(2, 1fr); }
          .hero h1 { font-size: 42px; }
        }

        @media (max-width: 640px) {
          .grid { grid-template-columns: 1fr; }
          .split-layout { grid-template-columns: 1fr; gap: 48px; }
          .hero h1 { font-size: 36px; }
          .card-actions { grid-template-columns: 1fr; }
        }
      `}</style>

      <header className="hero">
        <div className="container">
          <h1>Premium Car Wash Services</h1>
          <p>Experience the ultimate shine with our professional detailing and wash packages.</p>
          <a href="#packages" className="hero-btn">View Packages</a>
        </div>
      </header>

      <section id="packages" className="services-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Our Service Packages</h2>
            <p className="section-desc">We offer a range of services designed to meet your specific needs. Choose a package below to get started.</p>
          </div>
          <div className="grid">
            {SERVICES.map((service) => (
              <article key={service.id} className="card">
                <img src={service.img} alt={service.title} className="card-img" />
                <div className="card-body">
                  <h3 className="card-title">{service.title}</h3>
                  <div className="card-price">{service.price}</div>
                  <ol className="service-list">
                    {service.features.map((feature, idx) => (
                      <li key={idx}>{feature}</li>
                    ))}
                  </ol>
                  <div className="card-actions">
                    <button className="btn btn-call" onClick={handleCall}>
                      <Phone size={16} /> Request Call
                    </button>
                    <button className="btn btn-wa" onClick={handleWhatsApp}>
                      <MessageCircle size={16} /> WhatsApp
                    </button>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="info-section">
        <div className="container">
          <div className="split-layout">
            <div>
              <div className="section-header" style={{textAlign: 'left', marginBottom: '32px'}}>
                <h2 className="section-title" style={{fontSize: '24px'}}>Common Questions</h2>
                <p className="section-desc" style={{margin: 0, textAlign: 'left', fontSize: '16px'}}>Everything you need to know.</p>
              </div>
              {FAQS.map((item, i) => (
                <div key={i} className="faq-item">
                  <div className="faq-q">
                    {item.q}
                    <ChevronDown size={18} color="#FA8128"/>
                  </div>
                  <div className="faq-a">{item.a}</div>
                </div>
              ))}
            </div>

            <div>
              <div className="section-header" style={{textAlign: 'left', marginBottom: '32px'}}>
                <h2 className="section-title" style={{fontSize: '24px'}}>Happy Customers</h2>
                <p className="section-desc" style={{margin: 0, textAlign: 'left', fontSize: '16px'}}>Don't just take our word for it.</p>
              </div>
              <div className="testimonial">
                <p>"The team arrived on time and did an amazing job. My car looks brand new! I appreciate the attention to detail on the rims."</p>
                <div className="testimonial-author">
                  --- Sarah M.
                  <div className="stars" style={{marginLeft: 'auto'}}>
                    {[1,2,3,4,5].map(s => <Star key={s} size={14} fill="#FA8128" color="none"/>)}
                  </div>
                </div>
              </div>
              <div className="testimonial">
                <p>"Very convenient and professional. The ceramic coating service is worth every cent. Highly recommended for busy professionals."</p>
                <div className="testimonial-author">
                  --- James K.
                  <div className="stars" style={{marginLeft: 'auto'}}>
                    {[1,2,3,4,5].map(s => <Star key={s} size={14} fill="#FA8128" color="none"/>)}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

